import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import '../companyReceiptGoods/CompanyReceiptGoods.css';
import '../receiptGoods/ReceiptGoods.css';
import Header from "../header/Header";
import Menu from "../menu/Menu";
import MenuCompany from '../menu/MenuCompany';
import red_line from '../../img/red_line.png';
import { MobileMenu } from "../mobileMenu/MobileMenu";
import { setUserParams, updateCustomerData } from "../../features/customer/customerSlice";
import { getCustomerRecipients, setCompanyParams, setSelectedRow, setSelectedAddress } from "../../features/customer/companySlice"; 
import Test from '../test/Test';
import { useParams } from "react-router";
import { MobileMenuCompany } from "../mobileMenu/MobileMenuCompany";
import { setTargetCustomerParams } from "../../features/customer/targetCustomerSlice";
import '../pageSize/PageSize.css';
import { IS_INTERNAL_APP } from "../../api/ApiSettings";
import { NextAndBackButtons } from "../common/buttons/nextAndBackButtons/NextAndBackButtons";

const CompanyReceiptGoods = () => {
  const companyData = useSelector(state => state.company.companies[0]);
  const targetCustomer = useSelector(state => state.targetCustomer);
  const [editCustomerData, setEditCustomerData] = useState({});
  const companies = useSelector((state) => state.company.companies);
  const { selectedRow } = useSelector((state) => state.company);
  const [selectAddress, setSelectAddress] = useState('');
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  const [openContactForm, setOpenContactForm] = useState(false)
  const [optionAddress, setOptionAddress] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedCompany = companies.filter(company => company.companyTax === selectedRow.companyTax);
  const recipients = useSelector((state) => state.company.selectedAddress); 
  const [isAddressSelected, setIsAddressSelected] = useState(true);
  useEffect(() => {
    // Check if selectedRow and companyData are available
    if (!selectedRow || !companyData) {
      navigate('/companyComplaintRegistration');
    }
  }, [selectedRow, companyData, navigate]);
  
  useEffect(() => {
    setEditCustomerData({
      customerPersonName: targetCustomer.customerPersonName || "",
      email: targetCustomer.email || companyData.email || "",
      phone: targetCustomer.phone || companyData.phone || "",
      street: targetCustomer.street || companyData.street || "",
      buildingNumber: targetCustomer.buildingNumber || companyData.buildingNumber || "",
      flatNumber: targetCustomer.flatNumber || companyData.flatNumber || "",
      postalCode: targetCustomer.postalCode || companyData.postalCode || "",
      city: targetCustomer.city || companyData.city || "",
      country: targetCustomer.country || companyData.country || "PL"
    });
  }, [companyData, targetCustomer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditCustomerData(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  const validateForm = () => {
    const newErrors = {};
    if (!editCustomerData.customerPersonName) newErrors.customerPersonName = "Imię i nazwisko jest wymagane";
    if (!editCustomerData.email) newErrors.email = "E-mail jest wymagany";
    if (!editCustomerData.phone) newErrors.phone = "Telefon jest wymagany";
    if (!editCustomerData.street) newErrors.street = "Ulica jest wymagana";
    if (!editCustomerData.buildingNumber) newErrors.buildingNumber = "Nr domu jest wymagany";
    if (!editCustomerData.postalCode) newErrors.postalCode = "Kod pocztowy jest wymagany";
    if (!editCustomerData.city) newErrors.city = "Miejscowość jest wymagana";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedRow.id === 0) {
      if (validateForm()) {
        dispatch(setTargetCustomerParams(editCustomerData));
        navigate('/companySummary');
      }
    } else {
      if ((optionAddress === '' || optionAddress === 'Należy wybrać z listy') && IS_INTERNAL_APP === false) {
        setIsAddressSelected(false);
        return;
      }
      navigate('/companySummary');
    }
  };

  const handleBackClick = () => {
    navigate('/companyRegistration');
  };

  const handleAddressChange = event => {
    const selectedAddress = event.target.value;
    const selectedAddressObj = sortedSelectedCompany.find(address => address.fullAddress === selectedAddress);
    const selectedAddressId = selectedAddressObj ? selectedAddressObj.id : null;
    
    setOptionAddress(selectedAddress);
    setSelectAddress(selectedAddress);
    setIsAddressSelected(true);  // Zmiana na true, aby usunąć efekt walidacji
    
    dispatch(setSelectedAddress(selectedAddress));
    dispatch(getCustomerRecipients({ customerId: selectedAddressId }));
    
    if (selectedRow.id > -1) {
      dispatch(setTargetCustomerParams({
        ...selectedAddressObj,
        id: selectedAddressId, 
        phone: targetCustomer.phone, 
        email: targetCustomer.email 
      }));
    } else {
      dispatch(setTargetCustomerParams({ ...targetCustomer, id: selectedAddressId }));
    }
  };

  useEffect(() => {
    if (sortedSelectedCompany.length === 1) {
      const selectedAddress = sortedSelectedCompany[0].fullAddress;
      const selectedAddressId = sortedSelectedCompany[0].id;
      const selectedAddressFlatNumber = sortedSelectedCompany[0].flatNumber;
      const selectedAddressPostalCode = sortedSelectedCompany[0].postalCode;
      const selectedAddressCity = sortedSelectedCompany[0].city;
      const selectedAddressStreet = sortedSelectedCompany[0].street;

      setSelectAddress(selectedAddress); 
      dispatch(setSelectedAddress(selectedAddress));
      dispatch(getCustomerRecipients({ customerId: selectedAddressId }));
      if (selectedRow.id > -1) {
        dispatch(setTargetCustomerParams({ ...targetCustomer, id: selectedAddressId, 
                                                          fullAddress:  selectedAddress, 
                                                          flatNumber: selectedAddressFlatNumber, 
                                                          postalCode: selectedAddressPostalCode, 
                                                          city: selectedAddressCity,
                                                          street: selectedAddressStreet }));
      } else {
        dispatch(setTargetCustomerParams({ ...targetCustomer, id: selectedAddressId }));
      }
    }
  }, []);

  const sortedSelectedCompany = [...selectedCompany].sort((a, b) => {
    const cityA = a.city.toUpperCase();
    const cityB = b.city.toUpperCase();
    if (cityA < cityB) {
      return -1;
    }
    if (cityA > cityB) {
      return 1;
    }
    return 0;
  });
  
  useEffect(() => {
    if (selectedRow.id === 0) {
      const previouslySelectedAddress = targetCustomer.fullAddress || "";
      setOptionAddress(previouslySelectedAddress);
    } else if (sortedSelectedCompany.length === 1) {
      const selectedAddress = sortedSelectedCompany[0].fullAddress;
      setOptionAddress(selectedAddress);
    }
  }, [selectedRow.id, targetCustomer.fullAddress, sortedSelectedCompany]);

  return (
    <div className="page-size">
        <Header />
        {isMobile ? <MobileMenuCompany isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)} /> : <MenuCompany isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)} />}

        <div className="receipt-goods-container">
            <div className="receipt-goods-title">
                <img style={{ marginLeft: "0px" }} src={red_line} className='red-line' />
                <p className="receipt-goods-title-text">Miejsce odbioru towaru</p>
                
                <div className="receipt-goods-text">
                    Wskaż adres miejsca, do którego wyślemy kuriera po odbiór zgłaszanego produktu.
                </div>
            </div>
           
            {selectedRow.id === 0 ? (
              <div className="receipt-goods-form-container">
                <form className="address-form">
                  <div className="text-field">
                    <label>Imię i nazwisko</label>
                    <input 
                      type="text" 
                      className="frame-3" 
                      value={editCustomerData.customerPersonName}  
                      onChange={handleChange} 
                      name="customerPersonName"
                      style={{ borderColor: errors.customerPersonName ? 'red' : '#ccc' }}
                    />
                    {errors.customerPersonName && <p className="error">{errors.customerPersonName}</p>}
                  </div><br/>
                  <div className="text-field">
                    <label>E-mail</label>
                    <input 
                      type="text" 
                      className="frame-3" 
                      value={editCustomerData.email} 
                      onChange={handleChange} 
                      name="email"
                      style={{ borderColor: errors.email ? 'red' : '#ccc' }}
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </div><br/>
                  <div className="text-field">
                    <label>Telefon</label>
                    <input 
                      type="text" 
                      className="frame-3" 
                      value={editCustomerData.phone} 
                      onChange={handleChange} 
                      name="phone" 
                      style={{ borderColor: errors.phone ? 'red' : '#ccc' }}
                    />
                    {errors.phone && <p className="error">{errors.phone}</p>}
                  </div><br/>
                  <div className="text-field">
                    <label>Ulica</label>
                    <input 
                      type="text" 
                      className="frame-3" 
                      value={editCustomerData.street} 
                      onChange={handleChange} 
                      name="street"
                      style={{ borderColor: errors.street ? 'red' : '#ccc' }}
                    />
                    {errors.street && <p className="error">{errors.street}</p>}
                  </div><br/>
                  <div className="text-field">
                    <label>Nr domu</label>
                    <input 
                      type="text" 
                      className="frame-3" 
                      value={editCustomerData.buildingNumber} 
                      onChange={handleChange} 
                      name="buildingNumber"
                      style={{ width: "10vw",borderColor: errors.buildingNumber ? 'red' : '#ccc' }}
                    />
                    {errors.buildingNumber && <p className="error">{errors.buildingNumber}</p>}
                  </div><br/>
                  <div className="text-field">
                    <label className="frame-584">Nr lokalu <p className="optional">Opcjonalnie</p></label>
                    <input 
                      type="text" 
                      style={{width: "10vw"}} 
                      className="frame-3"  
                      value={editCustomerData.flatNumber} 
                      onChange={handleChange} 
                      name="flatNumber"
                    />
                  </div><br/>
                  <div className="text-field">
                    <label>Kod pocztowy</label>
                    <input 
                      type="text" 
                      className="frame-3" 
                      value={editCustomerData.postalCode} 
                      onChange={handleChange} 
                      name="postalCode"
                      style={{ borderColor: errors.postalCode ? 'red' : '#ccc' }}
                    />
                    {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                  </div><br/>
                  <div className="text-field">
                    <label>Miejscowość</label>
                    <input 
                      type="text" 
                      className="frame-3" 
                      value={editCustomerData.city} 
                      onChange={handleChange} 
                      name="city"
                      style={{ borderColor: errors.city ? 'red' : '#ccc' }}
                    />
                    {errors.city && <p className="error">{errors.city}</p>}
                  </div><br/>
                  <div className="text-field">
                    <label>Kraj</label>
                    <select 
                      style={{color:"#D5D5D5",fontWeight:"normal"}} 
                      className="frame-3" 
                      name="country" 
                      value={editCustomerData.country} 
                      onChange={handleChange}
                    >
                      <option value="PL">Polska</option>
                    </select>
                  </div><br/>
                </form>
                <div className="btn-frame" style={{ top:'1100px', bottom:'0px'}}>
                  <button className="prev-btn" onClick={handleBackClick}><p>Wróć</p></button>
                  <button className="next-btn" type="submit" onClick={handleSubmit}><p>Dalej</p></button>
                </div>  
              </div>
            ) : null}

            {selectedRow.id > 0 && (
              <div className="localization-container"> 
                <div className="localization-label">
                  <label>Lokalizacja</label>
                </div>
                {selectedCompany.length > 0 && (
                  <>
                    <select
                      onChange={handleAddressChange}
                      value={optionAddress || targetCustomer.fullAddress}
                      placeholder="Wybierz"
                      className='localization-input'
                      style={{
                        border: `${!isAddressSelected ? "1px solid red" : "1px solid #ccc"}`,
                      }}
                    >
                      <option value="" disabled selected>
                        Należy wybrać z listy
                      </option>
                      {sortedSelectedCompany.map((address) => (
                        <option key={address.id} value={address.fullAddress}>
                          <p style={{ fontFamily: 'Montserrat' }}>{address.city}, {address.fullAddress}</p>
                        </option>
                      ))}
                    </select>
                    {!isAddressSelected && <p className="error" style={{ marginTop: '0px' }}>Należy wybrać miejsce odbioru!</p>}
                  </>
                )}
              
              <NextAndBackButtons onBack={handleBackClick} onNext={handleSubmit}/>
                
              </div>
            )}
        </div>
    </div>
  );
}

export default CompanyReceiptGoods;
